import { useDecision } from '@optimizely/react-sdk'

/**
 * Reasons Optimizely uses when a flag key is absent from the datafile.
 * Until the flag exists, callers keep the local whitelabel default.
 */
const MISSING_FLAG = /not in the datafile|not found/i

/**
 * Resolves a whitelabel product toggle.
 * Optimizely overrides the local default once the SDK is ready and the flag
 * exists. Target audiences with the `whitelabel` user attribute
 * (`ss`, `birthday`, `eventfabula`, `cityhunt`).
 *
 * @param {string} flagKey - Optimizely flag key.
 * @param {boolean} fallback - Value from `getWhitelabelFeatures()` used before the flag exists.
 * @returns {boolean}
 */
export default function useWhitelabelFlag(flagKey, fallback) {
  const [decision, clientReady] = useDecision(flagKey)
  const reasons = decision?.reasons || []
  const missing = reasons.some((reason) => MISSING_FLAG.test(String(reason)))

  if (!clientReady || missing) {
    return fallback
  }

  return Boolean(decision.enabled)
}
